import ShareModal from './ShareModal.container'

export default ShareModal
